import type { SiteText } from "./types.js";

/** Srpski tekst sajta (ekavica, latinica) za vlasnika salona ili berbernice u Beogradu. Uređivali izvorni govornici, nije prevod. */
export const sr: SiteText = {
  nav: { pricing: "Cene", terms: "Uslovi", refund: "Povrat novca", privacy: "Privatnost", login: "Prijava", home: "Početna" },
  hero: {
    title: "Program za zakazivanje sa AI asistentom",
    text: "Kalendar za salone i berbernice koji rade po zakazivanju. AI asistent odgovara na pitanja klijenata u Instagram porukama i upisuje termine u vaš kalendar. Odgovara samo na osnovu podataka koje ste uneli.",
    cta: "Pogledajte cene",
    login: "Prijava za salone",
    note: "Bez naplate avansa od klijenata i bez masovnih poruka. Poslednja reč je uvek vaša.",
  },
  demo: {
    chatTitle: "Instagram Direct",
    messages: [
      { from: "client", text: "Zdravo! Imate li slobodan termin sutra posle 17h za fade?" },
      {
        from: "assistant",
        text: "Zdravo! Sutra posle 17h ima slobodnih termina: u 17:30 kod Marka i u 18:00 kod Nikole. Fade traje 30 minuta i košta 1.500 RSD. Koji termin vam odgovara?",
      },
      { from: "client", text: "17:30 kod Marka." },
      { from: "assistant", text: "Fade kod Marka sutra u 17:30, 1.500 RSD. Da zakažem?" },
      { from: "client", text: "Da." },
      { from: "assistant", text: "Zakazano: sutra u 17:30, fade kod Marka. Vidimo se!" },
    ],
    bookingTitle: "Kalendar",
    booking: { time: "17:30–18:00", client: "Luka", details: "Fade · Marko · zakazao asistent", status: "potvrđen" },
  },
  how: {
    title: "Kako radi",
    steps: [
      {
        title: "Povežite Instagram",
        text: "Profesionalni nalog salona povezujete preko zvanične Meta prijave, bez davanja lozinke i bez pristupa vašem telefonu.",
      },
      {
        title: "Unesite usluge i pravila",
        text: "Pošaljite cenovnik, fotografiju ili tekst: cene, trajanje, majstori, radno vreme i pravila otkazivanja unose se iz njih. Sve proverite pre nego što asistent počne da radi.",
      },
      {
        title: "Asistent odgovara i zakazuje",
        text: "Odgovara samo na osnovu podataka salona, nudi slobodne termine i upisuje zakazani termin u kalendar. Kada ne zna, prosleđuje razgovor vama ili majstoru.",
      },
    ],
  },
  features: {
    title: "Šta dobijate",
    items: [
      { title: "Kalendar", text: "Usluge sa cenom i trajanjem, majstori, rasporedi, slobodni dani i ručno zakazivanje u dva klika." },
      {
        title: "AI odgovori",
        text: "Cene, usluge, adresa, radno vreme i pravila: samo na osnovu podataka salona. Ako odgovora nema, asistent kaže: „Proveriću kod majstora.“",
      },
      {
        title: "Majstor uvek ima poslednju reč",
        text: "Obaveštenja stižu svim majstorima, tu je dugme „Preuzmi razgovor“, a dok majstor odgovara, asistent ćuti.",
      },
      { title: "Stranica za zakazivanje", text: "Link koji stavljate u bio na Instagramu i QR kod: klijent zakazuje bez dopisivanja." },
      { title: "Mesečni pregled", text: "Jednom mesečno, u jednom redu: koliko termina je zakazao asistent i kolika im je ukupna vrednost." },
      { title: "Bez avansa", text: "Ne naplaćujemo ništa vašim klijentima i ne šaljemo masovne poruke." },
    ],
  },
  pricingTeaser: {
    title: "Jedna cena, bez provizija",
    price: "25 €",
    per: "mesečno",
    points: [
      "Prvi mesec besplatno, naplata posle 30 dana",
      "Neograničen broj razgovora (uz dnevno ograničenje radi zaštite od spama)",
      "Pretplatu otkazujete kad god želite",
    ],
    cta: "Sve o cenama",
    setup: "Podešavanje je besplatno: oko 15 minuta, korak po korak.",
  },
  faq: {
    title: "Česta pitanja",
    items: [
      {
        q: "Da li klijenti znaju da im odgovara AI?",
        a: "Asistent sam ne kaže da je AI, ali na direktno pitanje odgovara iskreno. U podešavanjima možete uključiti opciju da se asistent odmah predstavi kao AI.",
      },
      {
        q: "Šta ako asistent ne zna odgovor?",
        a: "Kaže klijentu da će proveriti kod majstora i prosleđuje razgovor vama ili majstoru. Odgovorite jednom i asistent će to zapamtiti za sledeći put.",
      },
      {
        q: "Mogu li da preuzmem razgovor?",
        a: "Da, u svakom trenutku. Dok vi ili majstor odgovarate, asistent ćuti. Asistenta možete i potpuno pauzirati.",
      },
      {
        q: "Šta je potrebno za povezivanje?",
        a: "Profesionalni Instagram nalog salona i Meta poslovni portfolio. Povezujete se preko zvanične Meta prijave, a lozinku nam ne dajete.",
      },
      {
        q: "Koliko traje podešavanje?",
        a: "Oko 15 minuta, korak po korak: usluge, majstori, radno vreme, pravila. Ako negde zapnete, pišite nam i pomoći ćemo.",
      },
      {
        q: "Da li naplaćujete nešto mojim klijentima?",
        a: "Ne. Nema avansa, depozita ni masovnih poruka. Plaćate samo pretplatu salona.",
      },
      {
        q: "Mogu li da otkažem?",
        a: "Da, u bilo kom trenutku na stranici pretplate. Pristup ostaje do kraja plaćenog perioda.",
      },
    ],
  },
  pricing: {
    title: "Cene",
    subtitle: "Jedna pretplata za ceo salon: kalendar, asistent, stranica za zakazivanje i mesečni pregled.",
    plan: "Pretplata",
    price: "25 €",
    per: "mesečno",
    points: [
      "Bez provizija i bez ograničenja broja razgovora (uz dnevno ograničenje radi zaštite od spama)",
      "Prvi mesec besplatno: karticu unosite odmah, a naplata je posle 30 dana",
      "Pretplatu otkazujete kad god želite, bez godišnjeg ugovora",
    ],
    setupTitle: "Podešavanje",
    self: { title: "Sami podešavate", price: "Besplatno", text: "Podešavanje korak po korak, oko 15 minuta. Ako negde zapnete, pomoći ćemo." },
    vat: "Ako se plaća PDV, Paddle ga obračunava prema zemlji kupca i pre plaćanja prikazuje ukupan iznos.",
    mor: "Plaćanja obrađuje Paddle.com, naš Merchant of Record (zvanični prodavac) za sve porudžbine.",
    start: "Započnite",
  },
  footer: {
    rights: "Sva prava zadržana.",
    tagline: "Kalendar i AI asistent za salone koji rade po zakazivanju.",
    contact: "Kontakt",
    language: "Jezik",
    legal: "Dokumenti",
  },
  draft: "Nacrt: tekst još nije pregledao pravnik.",
  updated: "Poslednja izmena",
};
